/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
import { useState, useEffect, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getDaysInTreeWeeks } from '@helpers';
import {
  setCurrentTransaction,
  fetchCurrentRefund,
  fetchTransactions,
  changePagination,
  resetPagination as doResetPagination,
  moreTransactions as doMoreTransactions,
  changeFilter,
  exportTransactionsCsv as doExportTransactionsCsv,
  fetchTransactionsDetails,
} from '@store/transactions/actions';
import { isLimitMobile as doIsLimitMobile } from '@helpers/transactions';
import { selectRefundsSummary } from '@store/transactions/selectors';

const useTransaction = () => {
  const dispatch = useDispatch();
  const {
    merchantType,
    data: transactions,
    pagination,
    filter,
    currentTransaction,
    currentRefund,
    isLoadingTransactions,
    isLoadingExport,
    isLoading,
    movements,
    errorTransactions,
  } = useSelector((state) => state.transactions);
  const refundsSummary = useSelector(selectRefundsSummary);

  const [currentDate, setCurrentDate] = useState();
  const [calendar, setCalendar] = useState([]);

  useEffect(() => {
    setCurrentDate(new Date());
  }, []);

  useEffect(() => {
    if (currentDate) {
      setCalendar(getDaysInTreeWeeks(currentDate));
    }
  }, [currentDate]);

  const getTransactions = useCallback(() => dispatch(fetchTransactions()), [dispatch]);
  const changedPagination = useCallback(
    (newPagination) => dispatch(changePagination(newPagination)),
    [dispatch]
  );
  const moreTransactions = useCallback(() => dispatch(doMoreTransactions()), [dispatch]);
  const resetPagination = useCallback(() => dispatch(doResetPagination()), [dispatch]);
  const updateFilter = useCallback((newFilter) => dispatch(changeFilter(newFilter)), [dispatch]);
  const getDetail = useCallback(
    (transaction) => dispatch(setCurrentTransaction(transaction)),
    [dispatch]
  );
  const getRefundDetail = useCallback(
    (transaction) => dispatch(fetchCurrentRefund(transaction)),
    [dispatch]
  );
  const exportTransactionsCsv = useCallback(() => dispatch(doExportTransactionsCsv()), [dispatch]);
  const isLimitMobile = () => doIsLimitMobile(pagination.perPage);
  const getTransactionsDetails = useCallback(
    (id, page, pageSize) => dispatch(fetchTransactionsDetails(id, page, pageSize)),
    [dispatch]
  );

  return {
    calendar,
    changedPagination,
    currentDate,
    currentRefund,
    currentTransaction,
    exportTransactionsCsv,
    errorTransactions,
    filter,
    getDetail,
    getRefundDetail,
    getTransactions,
    getTransactionsDetails,
    isLimitMobile,
    isLoading,
    isLoadingExport,
    isLoadingTransactions,
    merchantType,
    moreTransactions,
    movements,
    pagination,
    refundsSummary,
    resetPagination,
    transactions,
    updateFilter,
  };
};

export default useTransaction;
